
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/app.kpa`,
      template: `<dialog-component></dialog-component>
    <header>
        <!-- <app-bar></app-bar> -->
        <top-bar></top-bar>
    </header>

    <main>
        <router-view></router-view>
    </main>

    <footer>
        <footer-section></footer-section>
    </footer>
    
    <social-sidebar class="right"></social-sidebar>
    
    <cookie-banner></cookie-banner>`,
      style: ``,
      script: `(async () => { "use strict";
return {
    data: {},
};
 })()`
    };
  